import { Injectable } from '@angular/core';
import { DataPoint, Seuil } from '../models/modal-graph-forecast';
import { addMonths, subDays } from 'date-fns';
import { ModelService } from './model.service';

@Injectable({
  providedIn: 'root'
})
export class SeuilService {

  constructor(private modelService: ModelService) { }

  initializeSeuils(modelSeuils: any[], modelDataObservation: any[]): Seuil[] {
    const seuils: Seuil[] = [];
    modelSeuils.forEach(s => {
      const seuil = this.createSeuil(s, modelDataObservation);
      seuils.push(seuil);
    });
    return seuils;
  }

  private createSeuil(s: any, modelDataObservation: any[]): Seuil {
    const endDate = addMonths(new Date(), 6);
    const startDate = subDays(endDate, 365 * 10);
    const dataPoints: DataPoint[] = [];

    for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
      dataPoints.push({ date: date.toISOString(), value: this.getValueByMonth(s, date.getMonth()) });
    }

    return { name: s.nom, dataPoints, color: s.couleur };
  }

  private getValueByMonth(s: any, month: number): number {
    switch (month) {
      case 0: return s.jan;
      case 1: return s.fev;
      case 2: return s.mar;
      case 3: return s.avr;
      case 4: return s.mai;
      case 5: return s.jun;
      case 6: return s.jul;
      case 7: return s.aou;
      case 8: return s.sep;
      case 9: return s.oct;
      case 10: return s.nov;
      case 11: return s.dec;
      default: return 0;
    }
  }
}
